import cx from 'classnames';
import {ErrorMessage, Formik} from 'formik';
import appLogger from '@core/LoggingProvider';
import ProgressBar from '../ProgressBar';
import {Button, Message} from '@ultradent/components';
import Icon from '@components/common/Icon';
import AddressBookItem from '@components/account/AddressBook/AddressBookItem';
import RegistrationService from '@services/RegistrationService';
import {Navigate, useLocation, useNavigate, useOutletContext} from 'react-router-dom';

const MultipleAddresses = ( props ) => {
    const navigate = useNavigate();
    const context = useOutletContext();

    if ( !context.authorization( useLocation() ).hasMultipleAddresses() ) {
        return <Navigate to="/"/>
    }

    return (
        <div>
        <ProgressBar step={'3'} completed={[1, 1, 0]}
                     labels={['create login', 'verify account', 'finalize registration']}/>

        <h3 className="text-center md:text-lg font-normal">We have more than one address on file
            for this account. To ensure we ship your orders to the correct location, please select the default shipping
            address you would like to use for this login.</h3>

        <div className="universalForm-container text-near-black my-4 mx-auto">
            <Formik
                initialValues={{
                    addressID: '',
                    loading: false
                }}
                onSubmit={( values, {setStatus, setSubmitting} ) => {
                    values.loading = true;
                    const {dentistFullName, accountNumber, emailAddress, password} = context.state;
                    const registerUserInput = {
                        dentistFullName,
                        accountNumber: parseInt( accountNumber ),
                                    invoiceId: parseInt( context.state.invoiceId ),
                        defaultShippingAddressID: parseInt( values.addressID ),
                        emailAddress,
                        password
                    };
                    RegistrationService.createWebLoginForExistingCustomer( {input: registerUserInput} )
                        .then( resp => {
                            values.loading = false;
                            const emailAddress = context.state.emailAddress;
                            navigate( '/accountVerifiedNPI', {
                                state: {isSubmitted: true, emailAddress, registrationResult: resp.data?.createWebLoginForExistingCustomer}
                            } );
                        } )
                        .catch( errors => {
                            appLogger.capture( errors );
                            setSubmitting( false );
                            values.loading = false;
                            setStatus( {serverError: 'There was an error submitting this request, please try again.'} );
                        } );
                }}
                validate={formData => {
                    const {addressID} = formData;
                    const errors = {};

                    if ( !addressID ) {
                        errors.addressID = 'Please select a default shipping address.';
                    }

                    return errors;
                }}
                render={( {values, errors, status, touched, handleSubmit, handleChange, isSubmitting} ) => (
                    <fieldset className="universalForm">
                        {status &&
                            <Message notice
                                     className="flex font-normal items-center -ml-4 -mr-4 md:-ml-8 md:-mr-8 px-4 md:px-8 py-4 text-white w-auto mb-4">
                                <Icon.ui wrapperClassName="mr-2" className="text-white text-xl"
                                         name="report-problem-triangle"/>
                                <span className="message-bar-msg">{status.serverError || status.email}</span>
                            </Message>
                        }
                        <h1>Select your default shipping address: </h1>

                        <ul className="list-reset mt-4 mb-0">
                            {context.state.addresses.map( ( item ) => {
                                    const itemId = item.id;
                                    const isChecked = values.addressID === String( itemId );
                                    const groupId = 'addressID';
                                    return (
                                        <li className="address-item py-4">
                                            <label htmlFor={`${groupId}-${itemId}`}>
                                                <AddressBookItem {...item} annotation="">
                                                    <span className="wrap-check mr-4">
                                                        <input id={`${groupId}-${itemId}`}
                                                               type="radio"
                                                               name={groupId}
                                                               value={itemId}
                                                               onClick={handleChange}/>
                                                       <span className={`bg-white ${cx( 'radio',
                                                           {checked: isChecked} )}`}/>
                                                    </span>
                                                </AddressBookItem>
                                            </label>
                                        </li>
                                    );
                                }
                            )}
                        </ul>

                        {errors &&
                            <div className="text-fail mb-4">
                            <ErrorMessage name="addressID"/>
                        </div>}

                        <div className="button-bar flex-row mt-8 mx-0">
                            <span className="button tertiary"
                                  onClick={() => navigate( -1 )}
                                  style="margin-left: 0 !important;">Back</span>
                            <Button loading={values.loading}
                                    disabled={isSubmitting}
                                    primary
                                    onClick={handleSubmit} style="margin-right: 0 !important;">Next</Button>
                        </div>
                    </fieldset>
                )}/>
        </div>
    </div>
    );
}

export default MultipleAddresses;
